import Immutable from 'seamless-immutable';

export function stringArrayToObject(actionsArray, namespace = '') {
  if (actionsArray.some(actionName => !actionName || typeof actionName !== 'string')) {
    throw new Error('Action names must be strings and must not be empty');
  }
  const actions = Immutable(actionsArray);
  return Immutable.asObject(actions, actionName => [actionName, `${namespace}:${actionName}`]);
}
